<template>
  <div class="mt-60">
    <div class="row">
      <div class="col-lg-8 offset-lg-2 mb-12 h1 d-flex justify-content-center">
        <span class="extrabold">{{ dictionary.step1Label }}</span>
      </div>
      <div class="col-lg-8 offset-lg-2 mb-20">
        <div class="bold h4 text-center">
          {{ dictionary.step1SecondLabel }}
        </div>
      </div>
    </div>
    <div v-for="vehicle in vehicles" :key="vehicle.id" class="mb-60">
      <Vehicle
        ref="vehicle"
        :vehicle="vehicle"
        :panels="vehicles.length"
        :enable-buy-out="enableBuyOut"
        :enable-payment-in-advance="enablePaymentInAdvance"
        @remove-panel="removePanel"
        @vehicle-data="addVehicleData" />
    </div>
    <div class="row">
      <div class="col-lg-4 offset-lg-2 mb-30 mb-lg-0">
        <button
          type="button"
          class="btn btn-outline-primary btn-full-width"
          :disabled="maxPanels"
          @click="onAddVehicle">
          +&nbsp;{{ dictionary.addVehicleButtonText }}
        </button>
      </div>
      <div class="col-lg-4">
        <button
          type="button"
          class="btn btn-primary btn-full-width"
          @click="onClickSubmit">
          {{ dictionary.personalDataButtonText }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import * as lib from '../../../lib/lib'
import Vehicle from './Vehicle.vue'
import { v4 as uuidv4 } from 'uuid'
import useVuelidate from '@vuelidate/core'

export default {
  components: { Vehicle },
  props: {
    step: {
      required: true,
      type: Number,
    },
    vehiclesData: {
      required: false,
      type: Array,
      default: () => [{ id: uuidv4() }],
    },
  },
  emits: ['get-step', 'vehicle-data'],
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      scrollOffsetY: 125,
      isLoading: false,
      errorMsgs: [],
      title: '',
      secondTitle: '',
      vehicles: [{ id: uuidv4() }],
      enableBuyOut: false,
      enablePaymentInAdvance: false,
    }
  },
  computed: {
    goNextStep() {
      return this.step + 1
    },
    maxPanels() {
      if (this.configuration.maxItems > this.vehicles.length) {
        return false
      }
      return true
    },
  },
  mounted() {
    lib.removeURLParameter('page')

    const {
      brands,
      model,
      vehicleType,
      programmeType,
      leaseDuration,
      enableBuyOut,
      enablePaymentInAdvance,
      paymentInAdvance,
      fuelTypes,
    } = lib.getData('quotationData')

    this.enableBuyOut = enableBuyOut
    this.enablePaymentInAdvance = enablePaymentInAdvance

    const data = {}

    if (brands.find((item) => item.selected)) {
      data.Brand = brands.find((item) => item.selected).value
    }
    if (model) {
      data.Model = model.length ? model : ''
    }
    if (vehicleType) {
      data.VehicleType = vehicleType.length ? vehicleType : ''
    }
    if (programmeType) {
      data.ProgrammeType = programmeType.length ? programmeType : ''
    }
    if (fuelTypes.find((item) => item.selected)) {
      data.FuelType = fuelTypes.find((item) => item.selected).value
    }
    if (leaseDuration) {
      data.LeaseDuration = leaseDuration
      data.DurationIsPreselected = true
    }

    if (paymentInAdvance !== null && paymentInAdvance !== undefined) {
      data.PaymentInAdvance = paymentInAdvance
    }

    this.vehicles[0] = {
      ...this.vehicles[0],
      ...data,
    }

    lib.removeURLParameter('page')

    this.$nextTick(() => {
      lib.scrollToTop()
      this.setVehicleData()
    })
  },
  methods: {
    setVehicleData() {
      if (!this.vehiclesData.length) {
        return false
      }
      this.vehicles = this.vehiclesData
    },
    onAddVehicle() {
      this.vehicles.push({ id: uuidv4() })
    },
    addVehicleData(data) {
      const vehicleIndex = this.vehicles.indexOf(
        this.vehicles.find((item) => item.id === data.id)
      )

      this.vehicles[vehicleIndex] = {
        ...this.vehicles[vehicleIndex],
        ...data,
      }
    },
    onClickSubmit() {
      this.v$.$validate()

      if (this.v$.$invalid) {
        this.$nextTick(() => {
          lib.scrollToValidation(this.scrollOffsetY)
        })

        return false
      }
      for (let i = 0; i < this.vehicles.length; i++) {
        this.$refs.vehicle[i].collectData()
      }
      this.$emit('vehicle-data', this.vehicles)
      this.$emit('get-step', this.goNextStep)
    },
    removePanel(id) {
      this.vehicles = this.vehicles.filter((vehicle) => vehicle.id !== id)
    },
  },
}
</script>
